import { useMutation, useQuery } from '@tanstack/react-query'
import { createGame, getAvailableGames, joinGame, leaveGame } from './api'
import type { GameCreationParams } from '@/tygo/dto'

export function useCreateGameMutation() {
  return useMutation({
    mutationFn: (params: GameCreationParams) => createGame(params),
  })
}

export function useGetAvailableGamesQuery() {
  return useQuery({
    queryKey: ['availableGames'],
    queryFn: () => getAvailableGames(),
    refetchInterval: 1000 * 5,
  })
}

export function useJoinGameMutation() {
  return useMutation({
    mutationFn: ({ gameId, buyInAmount }: { gameId: string; buyInAmount: number }) =>
      joinGame(gameId, buyInAmount),
  })
}

export function useLeaveGameMutation() {
  return useMutation({
    mutationFn: (gameId: string) => leaveGame(gameId),
  })
}
